import type { SVGProps } from "react";

export function Email(props: SVGProps<SVGSVGElement>) {
  return (
    <div className="icon-email">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        height="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill="currentColor"
          d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
        ></path>
      </svg>
    </div>
  );
}
